import '@/hooks';

import Vue from 'vue';

import '@/plugins/bugsnag';
import '@/plugins/ckeditor';
import '@/plugins/vue-moment';
import '@/plugins/vuetify';
import '@/registerServiceWorker';
import router from '@/router';
import store from '@/store';

import App from '@/App.vue';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
